/** @format */

const objects = {
  useLocal11: true,
  dialogWidth: 1300,
  rooms_count: [
    { value: 0, text: 'Студия' },
    { value: 1, text: 1 },
    { value: 2, text: 2 },
    { value: 3, text: 3 },
    { value: 4, text: 4 },
    { value: 5, text: 5 },
    { value: 6, text: 6 },
    { value: 7, text: 7 },
    { value: 8, text: 8 },
    { value: 9, text: 9 },
    { value: 10, text: 10 },
    { value: 11, text: 11 },
    { value: 12, text: 12 },
    { value: 13, text: 13 },
    { value: 14, text: 14 },
    { value: 15, text: 15 },
    { value: 16, text: 16 },
    { value: 17, text: 17 },
    { value: 18, text: 18 },
    { value: 19, text: 19 },
    { value: 20, text: 20 },
    { value: 100, text: 'Свободная' },
  ],
  list: [
    { name: 'id', title: '#', type: 'id', sortable: true, width: 50 },
    {
      name: 'object_type',
      title: 'Работы на объекте',
      type: 'selectbit',
      options: [
        { value: 1, text: 'Дизайн' },
        { value: 2, text: 'Ремонт' },
        { value: 3, text: 'Мебель' },
      ],
    },
    {
      name: 'object_group',
      title: 'Тип',
      type: 'select',
      options: [
        { value: 0, text: 'Инвесторский' },
        { value: 1, text: 'Дизайн' },
        { value: 2, text: 'Ремонт' },
        { value: 3, text: 'Мебель' },
      ],
      filter: { name: 'status' },
      sortable: true,
      width: 200,
      hidden: false,
    },
    { name: 'name', title: 'Название', type: 'string', style: 'white-space: normal;', sortable: true, width: 200 },
    { name: 'city', title: 'Город', type: 'string', filter: { name: 'city', type: 'select', options: 'city' }, sortable: true, width: 150 },
    { name: 'address', title: 'Адрес', type: 'string', style: 'white-space: normal;', class: 'text-max-line-2', sortable: true, width: 300 },
    { name: 'status', title: 'Статус', type: 'select', options: 'status_object', sortable: true, width: 100 },
    {
      name: 'is_investor',
      title: 'Тип участия',
      type: 'select',
      options: [
        { value: 1, text: 'Инвестор' },
        { value: 0, text: 'Клиент' },
      ],
      width: 90,
    },
    { name: 'plan_date_finish', title: 'Дата сдачи', type: 'date', sortable: true, width: 70 },
    { name: 'type', title: 'Тип', type: 'select', sortable: true, width: 90, options: 'objectTypes' },
    { name: 'class', title: 'Класс', type: 'select', options: 'objectClasses', sortable: true, width: 90 },
    { name: 'ap_area', title: 'Площадь', type: 'string', sortable: true, width: 70 },
    { name: 'ap_rooms', title: 'Комнат', type: 'select', sourceList: 'rooms_count', sortable: true, width: 70 },
    { name: 'ap_ceiling_height', title: 'Потолки', type: 'string', sortable: true, width: 70 },
    { name: 'object_access', type: 'string', hidden: true },
    {
      name: 'object_design',
      title: 'Дизайнер',
      type: 'string',
      sortable: false,
      searchable: false,
      calculated: true,
      formula: '((d) => {return d.users_access.find((u)=>{return u.role==55})?.name;})',
      style: 'white-space: normal;',
      filter: { type: 'selectapi', name: 'objects_access.user_id', api: '/manager/users/select', filters: { role: 55 } },
      access: { role: [-1, -10] },
    },
    { name: 'client_id', type: 'select', dir: 'client', style: 'white-space: normal;', width: 300, hidden: true },
  ],
  form: [
    { name: 'name', title: 'Название', type: 'string', validator: ['req'], autofocus: true },
    { name: 'source', title: 'Источник', type: 'comboboxapi', api: '/mechti/objects/tags/source', chips: false, validator: [] },
    { name: 'link_ref', title: 'Ссылка', type: 'string', isMenu: true },
    { name: 'city', title: 'Город', validator: ['req'], type: 'comboboxapi', api: '/mechti/objects/tags/city', chips: false, rating: true, hint: 'Укажите город\nааа' },
    { name: 'address', title: 'Адрес', validator: ['req'], type: 'string', rating: true },
    { name: 'class', title: 'Класс', type: 'select', options: 'objectClasses', rating: true },
    { name: 'type', title: 'Тип', type: 'select', options: 'objectTypes', validator: ['req'], rating: true },
    { name: 'ap_price_buy', title: 'Стоимость покупки', validator: ['req'], type: 'number', rating: true },
    { name: 'ap_area', title: 'Площадь', type: 'number', validator: ['req', 'min#1'], rating: true },
    { name: 'ap_kitchen_area', title: 'Кухня м2', type: 'number', validator: ['req', 'min#1'] },
    { name: 'price_m2', title: 'Стоимость м2', type: 'number', disabled: true },
    { name: 'building_type', title: 'Тип здания', type: 'select', validator: ['req'], options: 'building_type' },
    { name: 'ap_rooms', title: 'Кол-во комнат', type: 'select', sourceList: 'rooms_count', rating: true, validator: 'req,min#0' },
    { name: 'ap_ceiling_height', title: 'Высота потолков', type: 'number', rating: true },
    { name: 'ap_layout', title: 'Планировка', type: 'text', rating: true },
    { name: 'ap_level', title: 'Уровней', type: 'number', rating: true },
    { name: 'ap_floor', title: 'Этаж', type: 'number', rating: true, validator: ['req', 'min#1'] },
    { name: 'building_floors', title: 'Этажей', type: 'number', validator: ['req', 'min#1'] },
    { name: 'ap_number', title: '№ квартиры', type: 'number', validator: ['req', 'min#1'] },
    { name: 'ap_view', title: 'Вид из окна', type: 'text', rating: true },
    { name: 'infrastructure', title: 'Инфраструктура', type: 'comboboxapi', api: '/mechti/objects/tags/infrastructure', chips: true, rating: true },
    { name: 'metro1', title: 'Метро', type: 'comboboxapi', api: '/mechti/objects/tags/metro', chips: true, rating: true, size: 6 },
    { name: 'metro', title: 'Метро', type: 'comboboxapi', api: '/mechti/underground_stations/select', fields: { value: 'text' }, chips: true, rating: true, size: 6 },
    { name: 'nearby', title: 'в 5 мин доступности', type: 'comboboxapi', api: '/mechti/objects/tags/nearby', chips: true, default: [], rating: true },
    { name: 'description', title: 'Описание', type: 'text' },
    { name: 'photos', title: 'Галерея', type: 'images', reverce: true },
    { name: 'photos_design', title: 'Дизайн-проект', type: 'images' },
    { name: 'docs', title: 'Проектная документация', type: 'files' },
    { name: 'docs_adv', title: 'Рекламные материалы', type: 'files', json: true },
    { name: 'docs_law', title: 'Юридические документы', type: 'files', json: true },
    { name: 'docs_furniture', title: 'Документы по мебели', type: 'files', json: true },
    { name: 'status', title: 'Статус', type: 'select', options: 'status_object', default: 10 },
    { name: 'data.vendor', title: 'Продавец', type: 'text', size: 6 },
    {
      name: 'residential_complex_id',
      title: 'ЖК',
      type: 'selectapi',
      api: 'mechti/residential_complex/select',
      validator: ['reqF'],
      validateFunc: '(d)=>{return !(d?.residential_type === 0 && !d?.residential_complex_id) || d?.type===1}',
      cascade: { 'data.residential_block': { type: 'value', value: 'null' } },
    },
    { name: 'residential_type', title: 'тип недвижимости', type: 'select', options: 'residential_type', validator: ['req'] },
    {
      name: 'data.residential_block',
      title: 'Корпус',
      type: 'selectapi',
      menuToggle: true,
      api: { type: 'post', api: '/report_sql', data: { name: 'getResidentialBlocks', params: { id: '(function(d) {return d?.residential_complex_id || 0})' } } },
    },
    { name: 'buyer_id', title: 'покупатель', type: 'selectapi', api: 'mechti/clients/select', optionsFilter: {} },
    { name: 'client_id', title: 'Клиент', type: 'select', dir: 'client', api1: 'mechti/clients/select', optionsFilter1: {} },
    { name: 'object_access', title: 'Сотрудники', type: 'selectuser', chips: true },
    { name: 'investor_id', title: 'Инвестор', type: 'selectapi', api: 'mechti/investors/select' },
    { name: 'status_fin', title: 'Финансовый статус' },
    { name: 'object_design', title: 'Дизайнер проекта' },
    { name: 'investment_amount', title: 'Сумма по договору', type: 'number', json: true },
    { name: 'ap_price_sell', title: 'Стоимость продажи', type: 'number', disabled: true },
    { name: 'filesRemove', default: [], hidden: true },
    { name: 'filesAdd', default: [], hidden: true },
    { name: 'doc', title: 'Проектная документация', type: 'filesdata', category: 1, hiddenCreate: true },
    { name: 'doc_adv', title: 'Рекламные материалы', type: 'filesdata', category: 2, hiddenCreate: true },
    { name: 'doc_law', title: 'Юридические документы', type: 'filesdata', category: 3, hiddenCreate: true },
    { name: 'doc_furniture', title: 'Документы по мебели', type: 'filesdata', category: 4, hiddenCreate: true },
    { name: 'loan_schedule', title: 'График выплат', default: '', type: 'string' },
    { name: 'is_investor', title: 'Тип участия', type: 'number', default: 0, validator: ['req'] },
    { name: 'credit_sum', title: 'Сумма ипотеки', type: 'number', size: 6 },
    { name: 'credit_rate' },
    { name: 'credit_date_start' },
    { name: 'credit_month_payment' },
    { name: 'data.donor_id', title: 'Собственник', type: 'selectapi', api: 'mechti/investors/select' },
    { name: 'data.is_procuratory', title: 'Доверенность', type: 'switcher' },
    { name: 'data.is_agreement_investor', title: 'Договор с инвестором', type: 'switcher' },
    { name: 'data.is_agreement_donor', title: 'Договор с собственником', type: 'switcher' },
    { name: 'data.doc_sell_price', title: 'Стоимость продажи по ДКП', type: 'number', size: 6 },
    { name: 'data.doc_buy_price', title: 'Стоимость покупки по ДКП', type: 'number', size: 6 },
    { name: 'data.investor_share', title: 'Доля прибыли инвестора', default: 50, type: 'number', size: 6, validator: ['min#0', 'max#100'] },
    { name: 'data.version', title: 'Версия объявления', type: 'string' },
    { name: 'credit_first_payment', title: 'Размер перв. взноса', type: 'number', size: 6 },
    { name: 'plan_month_expenses', title: 'Ежемесячные расходы', type: 'number', size: 6 },
    { name: 'plan_date_finish', title: 'Дата готовности', type: 'datestring', size: 6 },
    { name: 'plan_sell_period', title: 'Сроки готовности (мес)', type: 'number', size: 6 },
    { name: 'plan_sell_price', title: 'Стоимость продажи', type: 'number', size: 6 },
    { name: 'plan_expenses', title: 'Стоимость реализации проекта', type: 'number', size: 6 },
    { name: 'plan_org_expenses', title: 'Плановые расходы на оформление', type: 'number', size: 6 },
    { name: 'plan_investment', title: 'Плановые личные вложения', type: 'number', readonly: true, size: 6 },
    { name: 'plan_percent_investor', title: '', type: 'number', size: 6 },
    { name: 'layout_legal', title: 'Планировка узаконена', type: 'switcher' },
    { name: 'ap_area_real', title: 'Площадь по договору', type: 'number', size: 6 },
    { name: 'ap_area_plan', title: 'Площадь фактическая', type: 'number', size: 6 },
    { name: 'plan_investment_amount', title: 'Сумма инвестирования план', type: 'number' },
    {
      name: 'object_group',
      title: 'Тип объекта',
      type: 'select',
      options: [
        { value: 0, text: 'Инвесторский' },
        { value: 1, text: 'Дизайн (Клиент)' },
        { value: 2, text: 'Ремонт (Клиент)' },
        { value: 3, text: 'Мебель (Клиент)' },
      ],
      default: 0,
      validator: ['req'],
    },
    {
      name: 'object_type',
      title: 'Работы на объекте',
      type: 'selectbit',
      options: [
        { value: 1, text: 'Дизайн' },
        { value: 2, text: 'Ремонт' },
        { value: 3, text: 'Мебель' },
      ],
      validator: ['req'],
    },
    { name: 'data.rooms', title: 'Список комнат' },
    { name: 'status_site' },
    { name: 'bet' },
    { name: 'tech_requirements', title: 'Техническое задание', type: 'object-techrequirements' },
    { name: 'plan_solution', title: 'Планировочное решение', type: 'object-gallery', video: false },
    { name: 'style_compilation', title: 'Стилистическая подборка', type: 'object-gallery', video: false },
    { name: 'data.cadastralNumber', title: 'Кадастровый номер (участок)', type: 'string' },
    { name: 'data.passengerElevator', title: 'Пассажирские лифты', type: 'number', default: 0 },
    { name: 'data.freightElevator', title: 'Грузовые лифты', type: 'number', default: 0 },
    { name: 'data.balconies', title: 'Балконы', type: 'number', default: 0 },
    { name: 'data.loggias', title: 'Лоджии', type: 'number', default: 0 },
    { name: 'data.wardrobe', title: 'Гардеробная', type: 'select', options: 'yesNo', default: 0 },
    { name: 'data.windows', title: 'Панорамные окна', type: 'select', options: 'yesNo', default: 0 },
    { name: 'data.separateWcsCount', title: 'Раздельные саузлы', type: 'number', default: 0 },
    { name: 'data.combinedWcsCount', title: 'Совмещенные санузлы', type: 'number', default: 0 },
    {
      name: 'data.parking',
      title: 'Парковка',
      type: 'select',
      chips: true,
      options: ['Подземная', 'Наземная многоуровневая', 'Открытая во дворе', 'За шлагбаумом во дворе'],
    },
    { name: 'ap_price_adv', title: 'Рекл. ст-ть', type: 'number', hint: 'Стоимость объекта для публикации на сайте, Авито и Циан.' },
    { name: 'data.isLandWithContract', title: 'Участок с подрядом', type: 'select', options: 'yesNo' },
    { name: 'data.landStatus', title: 'Статус участка', type: 'select', options: 'objectLandStatus' },
    { name: 'data.landArea', title: 'Площадь участка', type: 'number' },
    { name: 'data.houseAdditionally', title: 'Терраса', type: 'select', options: ['Терраса или веранда'] },
    { name: 'data.buildingCadastralNumber', title: 'Кадастровый номер (дом)', type: 'string' },
    { name: 'data.gasSupply', title: 'Газ', type: 'select', options: ['Нет', 'По границе участка', 'В доме'] },
    { name: 'data.waterSupply', title: 'Водоснабжение', type: 'select', options: ['Центральное', 'Скважина', 'Колодец'] },
    { name: 'data.sewerage', title: 'Канализация', type: 'select', options: ['Центральная', 'Септик'] },
    { name: 'data.parkingType', title: 'Парковка', type: 'select', options: ['Нет', 'Гараж', 'Парковочное место'] },
    { name: 'data.builtYear', title: 'Год постройки', type: 'number' },
    {
      name: 'data.wallsType',
      title: 'Материал стен',
      type: 'select',
      options: ['Кирпич', 'Брус', 'Бревно', 'Газоблоки', 'Металл', 'Пеноблоки', 'Сэндвич-панели', 'Ж/б панели'],
    },
    {
      name: 'data.heatingType',
      title: 'Отопление',
      type: 'select',
      chips: false,
      options: ['Центральное', 'Газовое', 'Электрическое', 'Жидкотопливный котёл', 'Камин', 'Печь'],
    },
    { name: 'data.settlementName', title: 'Коттеджный поселок', type: 'string' },
    { name: 'data.kp', title: 'ID коттеджного поселка', type: 'string' },
    { name: 'data.hasBathhouse', title: 'Баня', type: 'select', options: 'yesNo' },
    { name: 'data.hasPool', title: 'Бассейн', type: 'select', options: 'yesNo' },
    { name: 'data.propertyRights', title: 'Право собственности', type: 'select', chips: false, options: ['Собственник', 'Посредник'] },
    { name: 'data.decoration', title: 'Отделка', type: 'select', chips: false, options: ['Без отделки', 'Предчистовая', 'Чистовая'] },
    { name: 'user_id', title: ' Кому назначено', type: 'select', dir: 'user' },
    { name: 'data.file_ddu', title: 'Файл ДДУ', type: 'file' },
    { name: 'data.saleMethod', title: 'Способ продажи', type: 'select', chips: false, options: 'saleMethod' },
    {
      name: 'data.cpl_data',
      title: 'Данные продавца',
      type: 'objectForm',
      model: 'objects.cpl_model',
      validateFunc:
        '(d) => {               console.log({residential_type:d?.residential_type, type :d?.type, _noError:d.data.cpl_data});                return (d?.residential_type === 0 && d?.type === 2 && d?.data.cpl_data?._noError === true) || d?.residential_type !== 0 || d?.type !== 2;              }',
      validator: ['nError1', 'reqF'],
    },
    { name: 'data.contact_data', title: 'контактные данные', type: 'objectForm', model: 'objects.contact_model' },
  ],
  cpl_model: {
    form: [
      { name: 'lastname', title: 'Фамилия', type: 'string', validator: ['req'] },
      { name: 'firstname', title: 'Имя', type: 'string', validator: ['req'] },
      { name: 'secondname', title: 'Отчество', type: 'string' },
      {
        name: 'personType',
        title: 'Тип лица',
        type: 'select',
        options: [
          { value: 'legal', text: 'Юридическое' },
          { value: 'natural', text: 'Физическое' },
        ],
        validator: ['req'],
      },
      { name: 'inn', title: 'ИНН', type: 'string' },
      { name: 'rosreestrRegistrationNumber', title: 'Номер ДДУ', type: 'string' },
    ],
    config: {
      form: {
        title: 'Данные CPL',
        fields: 'lastname,firstname,secondname,personType,inn,rosreestrRegistrationNumber',
        fieldsRO: '',
        fieldsForm: 'lastname#4,firstname#4,secondname#4,personType,inn,rosreestrRegistrationNumber',
      },
    },
  },
  contact_model: {
    form: [
      { name: 'lastname', title: 'Фамилия', type: 'string', validator: [] },
      { name: 'firstname', title: 'Имя', type: 'string', validator: [] },
      { name: 'secondname', title: 'Отчество', type: 'string' },
      { name: 'phone', title: 'Телефон', type: 'stringmask', mask: '^[0-9]*.?,?[0-9]*$' },
      { name: 'note', title: 'Заметки', type: 'text' },
    ],
    config: {
      form: {
        title: 'Контактные данные',
        fields: 'lastname,firstname,secondname,phone,note',
        fieldsRO: '',
        fieldsForm: 'lastname#4,firstname#4,secondname#4,phone,note',
      },
    },
  },
  formInfo: { fields: 'investor_id,client_id,name,source,link_ref,city,address,ap_rooms' },
  formInfo_role10: { fields: 'client_id,city,address' },
  formSale: [
    { name: 'buyer_id', title: 'Покупатель', validator: ['req'], type: 'selectapi', api: 'mechti/clients/select', optionsFilter: {}, autofocus: true },
    { name: 'ap_price_sell', title: 'Сумма продажи', validator: ['req'], type: 'number' },
  ],
  listAgent: [
    { name: 'id', title: '#', type: 'id', sortable: true, width: 50 },
    {
      name: 'createdby_name',
      title: 'Автор',
      type: 'string',
      sortable: true,
      width: 150,
      filter: {
        api: { type: 'post', api: '/report_sql', data: { name: 'getUserList', params: { name: 'agentObject', type: 'createdby' } } },
        ' filters': {},
        name: 'createdby_id',
        type: 'selectapi',
        isActiveFunc: 'd.status===1 || d.status ===null',
      },
    },
    {
      name: 'user_name',
      title: 'Назначено',
      type: 'string',
      sortable: true,
      width: 150,
      filter: {
        api_: '/manager/users/select',
        api: { type: 'post', api: '/report_sql', data: { name: 'getUserList', params: { name: 'agentObject', type: 'user' } } },
        filters: {},
        name: 'user_id',
        type: 'selectapi',
        isActiveFunc: 'd.status===1 || d.status ===null',
      },
    },
    { name: 'source', title: 'Источник', type: 'string', sortable: true, width: 200, hidden: true },
    { name: 'name', title: 'Название', type: 'string', style: 'white-space: normal;', sortable: true, width: 200, link: { field: 'link_ref' } },
    { name: 'city', title: 'Город', type: 'string', sortable: true, width: 100 },
    { name: 'address', title: 'Адрес', type: 'string', sortable: true, width: 300 },
    { name: 'residential_type', title: 'тип недвижимости', type: 'select', options: 'residential_type', sortable: true, width: 80 },
    { name: 'status', title: 'Статус', type: 'select', options: 'config.statuses.lamp_object', sortable: true, width: 100 },
    { name: 'ap_price_adv', title: 'Рекл. ст-ть', type: 'number', sortable: true, width: 100 },
    { name: 'type', title: 'Тип', type: 'select', sortable: true, width: 100, options: 'objectTypes', hidden: true },
    { name: 'class', title: 'Класс', type: 'select', options: 'objectClasses', sortable: true, width: 100, hidden: true },
    { name: 'ap_floor', title: 'Этаж', type: 'number', sortable: true, width: 65 },
    { name: 'ap_rooms', title: 'Комнат', type: 'select', sourceList: 'rooms_count', sortable: true, width: 65 },
    { name: 'ap_area', title: 'Площадь', type: 'string', sortable: true, width: 65 },
    { name: 'ap_ceiling_height', title: 'Потолки', type: 'string', sortable: true, width: 65, hidden: true },
    {
      name: 'status_site',
      title: 'Сайт',
      type: 'selectbit',
      options: [
        { value: 2, text: 'Cайт' },
        { value: 3, text: 'Авито' },
        { value: 4, text: 'Циан' },
      ],
      sortable: true,
      width: 100,
    },
    { name: 'actions', title: 'Действия', width: 100 },
  ],
  config: {
    agentObjects: {
      config: [
        {
          value: [0, 6],

          info: 'квартира, апартаменты',
          fields: [
            'data.file_ddu,data.decoration,data.saleMethod,data.cpl_data,data.contact_data',
            'data.residential_block,data.propertyRights,link_ref,status,source,name,plan_sell_price,plan_expenses',
            'credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses',
            'data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor',
            'plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan',
            'layout_legal,ap_area,ap_kitchen_area,price_m2,,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height',
            'ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
            'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv',
            'data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe',
            'data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,status_site',
          ],
          fieldsForm: [
            'name,source#8,residential_type#4,link_ref,city#4,address#8,residential_complex_id#8,data.residential_block#4',
            'class#3,type#3,building_type#3,data.propertyRights#3,data.landStatus#3,hr',
            'ap_area_real#3,ap_area_plan#3,layout_legal#6',
            'data.file_ddu#6,data.saleMethod#6',
            'data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3',
            'data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,hr',
            'ap_area#3,ap_kitchen_area#3,ap_price_adv#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2',
            'ap_ceiling_height#2,ap_level#2,description,metro',
            'data.cpl_data,data.contact_data',
            'photos,photos_design,doc,doc_adv,doc_law',
          ],

          fieldsRO: '',

          fieldsReplace: {
            status_site: {
              name: 'status_site',
              title: 'Публиковать на',
              type: 'selectbit',
              options: [
                { value: 1, text: '1', default: true, show: false },
                { value: 2, text: 'Cайт' },
                { value: 3, text: 'Авито' },
                { value: 4, text: 'Циан' },
              ],
            },
            status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
          },
        },
        {
          value: [1, 2, 3, 4],

          info: 'дом',
          fields: [
            'data.cpl_data,data.contact_data,data.landStatus,link_ref,status,source,name,city,address,class,type,data.landArea,ap_area,building_floors',
            'data.settlementName,data.kp,data.hasBathhouse,data.hasPool',
            'data.houseAdditionally,data.buildingCadastralNumber,data.gasSupply,data.heatingType,data.waterSupply',
            'data.parkingType,data.sewerage,data.builtYear,data.wallsType',
            'ap_rooms,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
            'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber',
            'data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows',
            'data.separateWcsCount,data.combinedWcsCount,data.parking,status_site,data.propertyRights',
          ],
          fieldsRO: '', 
          fieldsForm: [
            'name,source#8,residential_type#4,link_ref,city#4,address#8,class#3,type#3,data.propertyRights#3,data.landStatus#3,hr',
            'data.settlementName#8,data.kp#4',
            'data.landArea#3,ap_area#3,building_floors#3,ap_rooms#3',
            'data.houseAdditionally#3,data.gasSupply#3,data.heatingType#3,data.waterSupply#3',
            'data.sewerage#3,data.parkingType#3,data.builtYear#3,data.wallsType#3',
            'data.hasBathhouse#2,data.hasPool#2,data.decoration#4,ap_price_adv#4',
            'data.cadastralNumber#6,data.buildingCadastralNumber#6,hr',
            'description,metro,data.contact_data',
            'photos,photos_design,doc,doc_adv,doc_law',
          ],
          fieldsReplace: {
            status_site: {
              name: 'status_site',
              title: 'Публиковать на',
              type: 'selectbit',
              options: [
                { value: 1, text: '1', default: true, show: false },
                { value: 2, text: 'Cайт' },
                { value: 3, text: 'Авито' },
                { value: 4, text: 'Циан' },
              ],
            },
            status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
            ap_area: { name: 'ap_area', title: 'Площадь дома', type: 'number', validator: ['req', 'min#1'] },
          },
        },
      ],
      0: {
        info: 'квартира',
        fields: [
          'data.file_ddu,data.decoration,data.saleMethod,data.cpl_data,data.contact_data',
          'data.residential_block,data.propertyRights,link_ref,status,source,name,plan_sell_price,plan_expenses',
          'credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses',
          'data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor',
          'plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan',
          'layout_legal,ap_area,ap_kitchen_area,price_m2,,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height',
          'ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
          'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv',
          'data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe',
          'data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,status_site',
        ],
        fieldsForm: [
          'name,source#8,residential_type#4,link_ref,city#4,address#8,residential_complex_id#8,data.residential_block#4',
          'class#3,type#3,building_type#3,data.propertyRights#3,data.landStatus#3,hr',
          'ap_area_real#3,ap_area_plan#3,layout_legal#6',
          'data.file_ddu#6,data.saleMethod#6',
          'data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3',
          'data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,hr',
          'ap_area#3,ap_kitchen_area#3,ap_price_adv#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2',
          'ap_ceiling_height#2,ap_level#2,description,metro',
          'data.cpl_data,data.contact_data',
          'photos,photos_design,doc,doc_adv,doc_law',
        ],

        fieldsRO: '',

        fieldsReplace: {
          status_site: {
            name: 'status_site',
            title: 'Публиковать на',
            type: 'selectbit',
            options: [
              { value: 1, text: '1', default: true, show: false },
              { value: 2, text: 'Cайт' },
              { value: 3, text: 'Авито' },
              { value: 4, text: 'Циан' },
            ],
          },
          status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
        },
      },
      1: {
        info: 'дом',
        fields: [
          'data.cpl_data,data.contact_data,data.landStatus,link_ref,status,source,name,city,address,class,type,data.landArea,ap_area,building_floors',
          'data.settlementName,data.kp,data.hasBathhouse,data.hasPool',
          'data.houseAdditionally,data.buildingCadastralNumber,data.gasSupply,data.heatingType,data.waterSupply',
          'data.parkingType,data.sewerage,data.builtYear,data.wallsType',
          'ap_rooms,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
          'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber',
          'data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows',
          'data.separateWcsCount,data.combinedWcsCount,data.parking,status_site,data.propertyRights',
        ],
        fieldsRO: '',
        fieldsForm: [
          'name,source#8,residential_type#4,link_ref,city#4,address#8,class#3,type#3,data.propertyRights#3,data.landStatus#3,hr',
          'data.settlementName#8,data.kp#4',
          'data.landArea#3,ap_area#3,building_floors#3,ap_rooms#3',
          'data.houseAdditionally#3,data.gasSupply#3,data.heatingType#3,data.waterSupply#3',
          'data.sewerage#3,data.parkingType#3,data.builtYear#3,data.wallsType#3',
          'data.hasBathhouse#2,data.hasPool#2,data.decoration#4,ap_price_adv#4',
          'data.cadastralNumber#6,data.buildingCadastralNumber#6,hr',
          'description,metro,data.contact_data',
          'photos,photos_design,doc,doc_adv,doc_law',
        ],
        fieldsReplace: {
          status_site: {
            name: 'status_site',
            title: 'Публиковать на',
            type: 'selectbit',
            options: [
              { value: 1, text: '1', default: true, show: false },
              { value: 2, text: 'Cайт' },
              { value: 3, text: 'Авито' },
              { value: 4, text: 'Циан' },
            ],
          },
          status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
          ap_area: { name: 'ap_area', title: 'Площадь дома', type: 'number', validator: ['req', 'min#1'] },
        },
      },
      2: {
        info: 'дача',
        fields: [
          'link_ref,data.landStatus,status,source,name,city,address,class,type,data.landArea,ap_area,building_floors,data.contact_data',
          'data.settlementName,data.kp,data.hasBathhouse,data.hasPool',
          'data.houseAdditionally,data.buildingCadastralNumber,data.gasSupply,data.heatingType,data.waterSupply',
          'data.parkingType,data.sewerage,data.builtYear,data.wallsType',
          'ap_rooms,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor',
          'photos,photos_design,doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type',
          'ap_price_adv,data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies',
          'data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,status_site,data.propertyRights',
        ],
        fieldsRO: '',
        fieldsForm: [
          'name,source#8,residential_type#4,link_ref,city#4,address#8,,class#3,type#3,data.propertyRights#3,data.landStatus#3,       hr',
          'data.settlementName#8,data.kp#4',
          'data.landArea#3,ap_area#3,building_floors#3,ap_rooms#3',
          'data.houseAdditionally#3,data.gasSupply#3,data.heatingType#3,data.waterSupply#3',
          'data.sewerage#3,data.parkingType#3,data.builtYear#3,data.wallsType#3',
          'data.hasBathhouse#3,data.hasPool#3,ap_price_adv#6',
          'data.cadastralNumber#6,data.buildingCadastralNumber#6,        hr',
          'description,metro,data.contact_data',
          'photos,photos_design,doc,doc_adv,doc_law',
        ],
        fieldsReplace: {
          status_site: {
            name: 'status_site',
            title: 'Публиковать на',
            type: 'selectbit',
            options: [
              { value: 1, text: '1', default: true, show: false },
              { value: 2, text: 'Cайт' },
              { value: 3, text: 'Авито' },
              { value: 4, text: 'Циан' },
            ],
          },
          status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
          ap_area: { name: 'ap_area', title: 'Площадь дома', type: 'number', validator: ['req', 'min#1'] },
        },
      },
      3: {
        info: 'котедж',
        fields: [
          'link_ref,data.landStatus,status,source,name,city,address,class,type,data.landArea,ap_area,building_floors,data.contact_data',
          'data.settlementName,data.kp,data.hasBathhouse,data.hasPool',
          'data.houseAdditionally,data.buildingCadastralNumber,data.gasSupply,data.heatingType,data.waterSupply',
          'data.parkingType,data.sewerage,data.builtYear,data.wallsType',
          'ap_rooms,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design,doc,doc_adv',
          'doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber,data.passengerElevator',
          'data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount',
          'data.parking,status_site,data.propertyRights',
        ],
        fieldsRO: '',
        fieldsForm: [
          'name,source#8,residential_type#4,link_ref,city#4,address#8,class#3,type#3,data.propertyRights#3,data.landStatus#3,hr',
          'data.settlementName#8,data.kp#4',
          'data.landArea#3,ap_area#3,building_floors#3,ap_rooms#3',
          'data.houseAdditionally#3,data.gasSupply#3,data.heatingType#3,data.waterSupply#3',
          'data.sewerage#3,data.parkingType#3,data.builtYear#3,data.wallsType#3',
          'data.hasBathhouse#3,data.hasPool#3,ap_price_adv#6',
          'data.cadastralNumber#6,data.buildingCadastralNumber#6',
          'hr,description,metro,data.contact_data',
          'photos,photos_design,doc,doc_adv,doc_law',
        ],
        fieldsReplace: {
          status_site: {
            name: 'status_site',
            title: 'Публиковать на',
            type: 'selectbit',
            options: [
              { value: 1, text: '1', default: true, show: false },
              { value: 2, text: 'Cайт' },
              { value: 3, text: 'Авито' },
              { value: 4, text: 'Циан' },
            ],
          },
          status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
          ap_area: { name: 'ap_area', title: 'Площадь дома', type: 'number', validator: ['req', 'min#1'] },
        },
      },
      4: {
        info: 'таунхаус',
        fields: [
          'link_ref,data.landStatus,status,source,name,city,address,class,type,data.landArea,ap_area,building_floors,data.contact_data',
          'data.settlementName,data.kp,data.hasBathhouse,data.hasPool',
          'data.houseAdditionally,data.buildingCadastralNumber,data.gasSupply,data.heatingType,data.waterSupply',
          'data.parkingType,data.sewerage,data.builtYear,data.wallsType',
          'ap_rooms,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
          'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber',
          'data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows',
          'data.separateWcsCount,data.combinedWcsCount,data.parking,status_site,data.propertyRights',
        ],
        fieldsRO: '',
        fieldsForm: [
          'name,source#8,residential_type#4,link_ref,city#4,address#8,class#3,type#3,data.propertyRights#3,data.landStatus#3,       hr',
          'data.settlementName#8,data.kp#4',
          'data.landArea#3,ap_area#3,building_floors#3,ap_rooms#3',
          'data.houseAdditionally#3,data.gasSupply#3,data.heatingType#3,data.waterSupply#3',
          'data.sewerage#3,data.parkingType#3,data.builtYear#3,data.wallsType#3',
          'data.hasBathhouse#3,data.hasPool#3,ap_price_adv#6',
          'data.cadastralNumber#6,data.buildingCadastralNumber#6',
          'hr,description,metro,data.contact_data',
          'photos,photos_design,doc,doc_adv,doc_law',
        ],
        fieldsReplace: {
          status_site: {
            name: 'status_site',
            title: 'Публиковать на',
            type: 'selectbit',
            options: [
              { value: 1, text: '1', default: true, show: false },
              { value: 2, text: 'Cайт' },
              { value: 3, text: 'Авито' },
              { value: 4, text: 'Циан' },
            ],
          },
          status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
          ap_area: { name: 'ap_area', title: 'Площадь дома', type: 'number', validator: ['req', 'min#1'] },
        },
      },
      accessName: 'agentObjects',
      api: '/mechti/agent_objects',
      fields: [
        'data.residential_block,data.propertyRights,link_ref,status,source,name,plan_sell_price,plan_expenses',
        'credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses',
        'data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor',
        'plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan',
        'layout_legal,ap_area,ap_kitchen_area,price_m2,,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height',
        'ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design',
        'doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv',
        'data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe',
        'data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,status_site,data.contact_data',
      ],
      fieldsForm: [
        'name,source#8,residential_type#4,link_ref,city#4,address#8,residential_complex_id#8,data.residential_block#4',
        'class#3,type#3,building_type#3,data.propertyRights#3',
        'ap_area_real#3,ap_area_plan#3,layout_legal#6',
        'data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3',
        'data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,hr',
        'ap_area#3,ap_kitchen_area#3,ap_price_adv#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2',
        'ap_ceiling_height#2,ap_level#2,description,metro,data.contact_data,photos,photos_design,doc,doc_adv,doc_law',
      ],
      fieldsRO: '',
      fieldsReplace: {
        status_site: {
          name: 'status_site',
          title: 'Публиковать на',
          type: 'selectbit',
          options: [
            { value: 1, text: '1', default: true, show: false },
            { value: 2, text: 'Cайт' },
            { value: 3, text: 'Авито' },
            { value: 4, text: 'Циан' },
          ],
        },
        status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 1 },
      },
      siteName: 'agentObjects',
      title: 'Агентский объект',
      viewForm2: {
        fields: 'user_id,link_ref,name,city,adress,residential_complex_id#8,residential_type#4,ap_rooms,ap_area,ap_price_buy,price_m2,building_floors,ap_floor',
      },
      viewName: 'objectsAgent_view',
      watch: 'residential_type',
    },

    considers: {
      title: 'Предложения',
      fields:
        'status,source,name,credit_sum,data.investor_share,plan_sell_price,plan_expenses,credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses,data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor,plan_date_finish,city,address,class,type,building_type,ap_area_real,ap_area_plan,layout_legal,ap_area,ap_kitchen_area,price_m2,ap_price_buy,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law,style_compilation,plan_solution,photos_design',
      fieldsRO: '',
      fieldsForm: 'object_square,comments',
      fieldsReplace: { status: { name: 'status', title: 'Статус', type: 'select', options: '', default: 0 } },
    },
    lampObjects: {
      accessName: 'lampObjects',
      siteName: 'lampObjects',
      viewName: 'objectsLamp_view',
      api: '/mechti/lamp_objects',
      title: 'Рекламный объект',
      fields:
        'link_ref,status,source,name,plan_sell_price,plan_expenses,credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses,data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor,plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan,layout_legal,ap_area,ap_kitchen_area,price_m2,,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,',
      fieldsRO: '',
      viewForm2: { fields: 'user_id,link_ref,name,city,adress,ap_rooms,ap_area,ap_price_buy,price_m2,building_floors,ap_floor' },
      fieldsForm:
        'source,name,link_ref,city#6,address#6,residential_complex_id#8,residential_type#4,class#4,type#4,building_type#4,ap_area_real#3,ap_area_plan#3,layout_legal#6,data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3,data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,hr,ap_area#3,ap_kitchen_area#3,ap_price_adv#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2,ap_ceiling_height#2,ap_level#2,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law',
      fieldsReplace: {
        status_site: {
          name: 'status_site',
          title: 'Публиковать на',
          type: 'selectbit',
          options: [
            { value: 1, text: '1', default: true, show: false },
            { value: 2, text: 'Cайт' },
            { value: 3, text: 'Авито' },
            { value: 4, text: 'Циан' },
          ],
        },
        status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 2 },
      },
    },
    leadObjects: {
      title: 'Данные объекта клиента',
      fields:
        'link_ref,source,name,plan_sell_price,plan_expenses,credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses,data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor,plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan,layout_legal,ap_area,ap_kitchen_area,price_m2,ap_price_buy,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type',
      fieldsRO: '',
      fieldsForm:
        'city#6,address#6,residential_complex_id#8,residential_type#4,class#4,type#4,building_type#4,ap_area_real#3,ap_area_plan#3,layout_legal#6,ap_area#2,ap_kitchen_area#2,price_m2#2,ap_price_buy#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2,ap_ceiling_height#2,ap_level#2,ap_layout#6,ap_view#6,infrastructure,nearby,description,metro',
    },
    object: {
      title: 'Данные объекта',
      fields:
        'residential_complex_id,residential_type,style_compilation,plan_solution,tech_requirements,name,city,address,class,type,ap_area,ap_rooms,ap_ceiling_height,ap_layout,ap_level,ap_floor,ap_view,infrastructure,metro,nearby,description,photos,photos_design,doc,doc_adv,ap_price_sell,object_group',
      fieldsRO: '',
      fieldsForm:
        'name,city,address,residential_complex_id#8,residential_type#4,class#6,type#6,ap_area#4,ap_rooms#4,ap_ceiling_height#4,ap_level#4,ap_floor#4,ap_price_sell#4,ap_layout,ap_view,infrastructure,metro,nearby,description,photos,photos_design,doc,doc_adv,tech_requirements',
    },
    objects: { siteName: 'objects' },
    partnerObjects: {
      accessName: 'agentObjects',
      siteName: 'agentObjects',
      viewName: 'objectsPartner_view',
      api: '/mechti/partner_objects',
      title: 'Партнерский объект',
      fields:
        'link_ref,status,source,name,plan_sell_price,plan_expenses,credit_first_payment,plan_org_expenses,data.doc_buy_price,data.doc_sell_price,plan_month_expenses,data.donor_id,plan_investment_amount,data.is_procuratory,data.is_agreement_investor,data.is_agreement_donor,plan_date_finish,city,address,residential_complex_id,class,type,building_type,ap_area_real,ap_area_plan,layout_legal,ap_area,ap_kitchen_area,price_m2,,ap_floor,building_floors,ap_number,ap_rooms,ap_ceiling_height,ap_level,ap_layout,ap_view,infrastructure,nearby,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law,photos_design,residential_complex_id,residential_type,ap_price_adv,data.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,',
      fieldsRO: '',
      viewForm2: {
        fields: 'user_id,link_ref,name,city,adress,residential_complex_id#8,residential_type#4,ap_rooms,ap_area,ap_price_buy,price_m2,building_floors,ap_floor',
      },
      fieldsForm:
        'source,name,link_ref,city#6,address#6,residential_complex_id#8,residential_type#4,class#4,type#4,building_type#4,ap_area_real#3,ap_area_plan#3,layout_legal#6,data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3,data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,hr,ap_area#3,ap_kitchen_area#3,ap_price_adv#6,ap_floor#2,building_floors#2,ap_number#2,ap_rooms#2,ap_ceiling_height#2,ap_level#2,description,metro,data.vendor,photos,photos_design,doc,doc_adv,doc_law',
      fieldsReplace: {
        status_site: {
          name: 'status_site',
          title: 'Публиковать на',
          type: 'selectbit',
          options: [
            { value: 1, text: '1', default: true, show: false },
            { value: 2, text: 'Cайт' },
            { value: 3, text: 'Авито' },
            { value: 4, text: 'Циан' },
          ],
        },
        status: { name: 'status', title: 'Статус', type: 'select', options: 'status_site', sourceList: 'config.statuses.lamp_object', default: 3 },
      },
    },
    site: {
      title: 'Данные объекта',
      fields:
        'residential_complex_id,residential_type,name,city,address,class,type,ap_area,ap_rooms,ap_ceiling_height,ap_layout,ap_level,ap_floor,ap_view,infrastructure,metro,nearby,description,photos,photos_design,doc,doc_adv,ap_price_selldata.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,',
      fieldsRO:
        'name,city,address,class,type,ap_area,ap_rooms,ap_ceiling_height,ap_layout,ap_level,ap_floor,ap_view,infrastructure,metro,nearby,description,photos,photos_design,doc,doc_adv,ap_price_selldata.cadastralNumber,data.passengerElevator,data.freightElevator,data.balconies,data.loggias,data.wardrobe,data.windows,data.separateWcsCount,data.combinedWcsCount,data.parking,',
      fieldsForm:
        'name,city,address,residential_complex_id#8,residential_type#4,class#6,type#6,ap_area#4,ap_rooms#4,ap_ceiling_height#4,ap_level#4,ap_floor#4,ap_price_sell#4,metro,data.cadastralNumber#12,data.passengerElevator#3,data.freightElevator#3,data.balconies#3,data.loggias#3,data.wardrobe#3,data.windows#3,data.separateWcsCount#3,data.combinedWcsCount#3,data.parking,description,photos,photos_design,doc,doc_adv',
    },
  },
  formSite: [
    { name: 'name', title: 'Название', type: 'string', validator: ['req'], autofocus: true },
    { name: 'city', title: 'Город', validator: ['req'], type: 'comboboxapi', api: '/mechti/objects/tags/city', chips: false, rating: true },
    { name: 'address', title: 'Адрес', validator: ['req'], type: 'string', rating: true },
    { name: 'class', title: 'Класс', type: 'select', options: 'objectClasses', rating: true },
    { name: 'type', title: 'Тип', type: 'select', options: 'objectTypes', validator: ['req'], rating: true },
    { name: 'ap_price_buy', title: 'Стоимость квартиры', validator: ['req'], type: 'number', rating: true },
    { name: 'ap_area', title: 'Площадь', type: 'number', validator: ['req'], rating: true },
    { name: 'ap_rooms', title: 'Количество комнат', type: 'number', rating: true },
    { name: 'ap_ceiling_height', title: 'Высота потолков', type: 'number', rating: true },
    { name: 'ap_layout', title: 'Планировка', type: 'text', rating: true },
    { name: 'ap_level', title: 'Уровней', type: 'number', rating: true },
    { name: 'ap_floor', title: 'Этаж', type: 'number', rating: true },
    { name: 'ap_view', title: 'Вид из окна', type: 'text', rating: true },
    { name: 'infrastructure', title: 'Инфраструктура', type: 'comboboxapi', api: '/mechti/objects/tags/infrastructure', chips: true, rating: true },
    { name: 'metro', title: 'Метро', type: 'comboboxapi', api: '/mechti/objects/tags/metro', chips: true, rating: true },
    { name: 'nearby', title: 'в 5 мин доступности', type: 'comboboxapi', api: '/mechti/objects/tags/nearby', chips: true, default: [], rating: true },
    { name: 'description', title: 'Описание', type: 'text' },
    { name: 'photos', title: 'Фото галерея', type: 'images' },
    { name: 'photos_design', title: 'Дизайн-проект', type: 'images' },
    { name: 'docs', title: 'Проектная документация', type: 'files' },
    { name: 'docs_adv', title: 'Рекламные материалы', type: 'files', json: true },
    { name: 'docs_law', title: 'Юридические документы', type: 'files', json: true },
    { name: 'docs_furniture', title: 'Документы по мебели', type: 'files', json: true },
    { name: 'status', title: 'Статус', type: 'select', options: 'status_object', default: 10 },
    { name: 'object_access', title: 'Сотрудники', type: 'selectapi', api: '/mechti/users', chips: true },
    { name: 'investor_id', title: 'Инвестор', type: 'selectapi', api: '/mechti/investors/select' },
    { name: 'ap_price_sell', title: 'Стоимость продажи', type: 'number', disabled: true },
    { name: 'doc', title: 'Проектная документация', type: 'filesdata', category: 1, hiddenCreate: true },
    { name: 'doc_adv', title: 'Рекламные материалы', type: 'filesdata', category: 2, hiddenCreate: true },
    { name: 'doc_law', title: 'Юридические документы', type: 'filesdata', category: 3, hiddenCreate: true },
    { name: 'doc_furniture', title: 'Документы по мебели', type: 'filesdata', category: 4, hiddenCreate: true },
    { name: 'residential_complex_id', title: 'ЖК', type: 'selectapi', api: 'mechti/residential_complex/select' },
    { name: 'residential_type', title: 'тип недвижимости', type: 'select', options: 'residential_type' },
  ],
  sources: { estimate: { api: '/accounting/doc/estimate', title: 'Выберите смету', model: 'documentEstimate', fields: 'code_doc,date_doc,type,client_id,lead_id' } },
};

export default objects;
